import React, { Component, Fragment } from 'react';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import Select from 'Components/Forms/Elements/Select';
import Grid from '@material-ui/core/Grid';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import { num, getSpaceAmount } from 'Shared/utilities';
import Loader from 'Pure/Loader';
import PDFIcon from 'Icons/PDFIcon';
import { action } from 'Shared/Routes';
import { coworking_place_types } from 'Shared/options';
const hour_options = [{
  value: "7",
  label: "7h"
}, {
  value: "8",
  label: "8h"
}, {
  value: "9",
  label: "9h"
}, {
  value: "10",
  label: "10h"
}, {
  value: "11",
  label: "11h"
}, {
  value: "12",
  label: "12h"
}, {
  value: "13",
  label: "13h"
}, {
  value: "14",
  label: "14h"
}, {
  value: "15",
  label: "15h"
}, {
  value: "16",
  label: "16h"
}, {
  value: "17",
  label: "17h"
}, {
  value: "18",
  label: "18h"
}, {
  value: "19",
  label: "19h"
}, {
  value: "20",
  label: "20h"
}, {
  value: "21",
  label: "21h"
}];
export default class ArrivalRow extends Component {
  state = {
    loading: false,
    modal: false,
    arrival_status: "",
    update_modal: false,
    custom_hour: this.props?.data?.end_hour,
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  modal_ref = React.createRef();
  update_modal_ref = React.createRef();
  openModal = ({
    arrival_status,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trigger: e?.target,
      arrival_status: arrival_status
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trigger: undefined,
      arrival_status: ""
    });
  };
  openUpdateBookingModal = ({
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      update_modal: true,
      update_modal_trigger: e?.target
    });
  };
  closeUpdateBookingModal = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      update_modal: false,
      update_modal_trigger: undefined
    });
  };
  updateBooking = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('updateBookingHours'), {
      id: props.data?.id,
      custom_hour: state.custom_hour
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      props.requestUpdate();
      component.update_modal_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  updateStatus = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('updateArrivalStatus'), {
      id: props.data?.id,
      arrival_status: state.arrival_status
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      props.requestUpdate();
      component.modal_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getHoursOption = () => {
    const component = this,
      props = this.props,
      state = this.state;
    moment.locale('fr');
    let hours = hour_options.filter(hour => num(hour.value, 0) >= num(props.data?.end_hour, 0));
    return hours;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data = {},
      blank = false,
      fields
    } = props;
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    let new_amount = getSpaceAmount({
      pricings: data.coworking_space?.pricings || {},
      disposition_seat: data.coworking_space?.disposition_seat,
      schedule_price: data.coworking_space?.schedule_price,
      people: data.number_of_people,
      date: data.date,
      start_hour: data.start_hour,
      end_hour: state?.custom_hour,
      space_type: data.coworking_space?.type,
      roles: data.customer?.roles?.[0] || ''
    });
    new_amount = new_amount - data?.amount;
    let start_hour, duration;
    if (data.coworking_space?.type !== 'a_calm_coworking_space') {
      start_hour = data.type === 'afternoon' ? 'Après midi' : data.type === 'morning' ? 'Matin' : 'Journée';
      duration = data.type === 'day' ? 'Journée' : 'Demi-journée';
    } else {
      start_hour = data.start_hour + 'h';
      const diff = num(data.end_hour, 0) - num(data.start_hour, 0);
      duration = num(diff < 0 ? diff * -1 : diff, 0) + 'h';
    }
    let output = /*#__PURE__*/React.createElement("div", {
      className: !data.packorder ? "c-dashboard__row" : "c-dashboard__row c-dashboard__row--company"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-date"
    }, start_hour), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-amount"
    }, data.customer?.lastname, ' ', data.customer?.firstname), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-type"
    }, coworking_place_types.find(opt => opt.value === data.coworking_space?.type)?.front_short_label), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-amount"
    }, duration), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-PDF"
    }, !data.packorder ? /*#__PURE__*/React.createElement("a", {
      href: action('getBookingPDF').replace(':booking_id', data.id),
      target: "_blank",
      type: "application/pdf",
      rel: "noopener noreferrer",
      className: "c-dashboard__pdf-link"
    }, /*#__PURE__*/React.createElement(PDFIcon, {
      className: "c-dashboard__pdf-icon"
    })) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-status"
    }, data.arrival_status === 'no_show' ? 'No show' : data.arrival_status === 'departs' ? 'Départs' : data.arrival_status === 'arrivees' ? 'Arrivées' : 'Attendus'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Arrival-actions"
    }, data.arrival_status === "arrivees" ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-dashboard__cell-info ",
      variant: "contained",
      title: "Changer le statut en 'D\xE9parts'",
      onClick: e => component.openModal({
        arrival_status: "departs",
        e: e
      })
    }, "D\xE9part")) : data.arrival_status !== "departs" && data.arrival_status !== "arrivees" && data.arrival_status !== "no_show" ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "contained",
      className: "c-dashboard__cell-info u-margin-right-15",
      title: "Changer le statut en 'Arriv\xE9es'",
      onClick: e => component.openModal({
        arrival_status: "arrivees",
        e: e
      })
    }, "Arriv\xE9"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      variant: "contained",
      className: "c-dashboard__cell-info ",
      title: "Changer le statut en 'No show'",
      onClick: e => component.openModal({
        arrival_status: "no_show",
        e: e
      })
    }, "No show")) : undefined), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.modal,
      title: "Changement de statut",
      trigger_src: state.modal_trigger,
      "close-ref": component.modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'small'],
      onClose: component.closeModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Changer de statut :", state.arrival_status === 'no_show' ? 'No show' : state.arrival_status === 'departs' ? 'Départs' : "Arrivées")), getFormStatus(state), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.updateStatus
    }, loader, "Valider le changement de statut"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.modal_ref?.current?.click()
    }, "Fermer"))), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.update_modal,
      title: "Modification de la r\xE9servation",
      trigger_src: state.update_modal_trigger,
      "close-ref": component.update_modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'medium'],
      onClose: component.closeUpdateBookingModal
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(Select, {
      options: component.getHoursOption(),
      defaultValue: data.end_hour,
      onChange: component.handleChange,
      value: state.custom_hour,
      name: "custom_hour",
      type: "text",
      label: "Heure de d\xE9part",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, "Cr\xE9dits : ", data?.amount, /*#__PURE__*/React.createElement("br", null), state.custom_hour !== data.end_hour ? /*#__PURE__*/React.createElement("strong", null, "Cr\xE9dits suppl\xE9mentaires \xE0 utiliser : ", new_amount) : undefined)), getFormStatus(state), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.updateBooking
    }, loader, "Valider la modification de la r\xE9servation"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.update_modal_ref?.current?.click()
    }, "Fermer"))));
    return output;
  }
}
